<template>
  <div :class="$style.login">
    <div :class="$style.mask"></div>
    <div :class="$style.context">
      <div :class="$style.bindAccount">
        <p :class="$style.notice">忘记密码</p>
        <div :class="$style.formItem">
          <span :class="`${$style.label} ${!active && $style.active}`">手机</span>
          <Field v-model="phone" :class="`${$style.value} ${!active && $style.active}`" @focus="handleBlur(0)">
            <template v-slot:right-icon>
              <i class="iconfont yw-guanbi1" @click="username = ''"></i>
            </template>
          </Field>
        </div>
        <div :class="$style.formItem">
          <span :class="`${$style.label} ${active === 1 && $style.active}`">新密码</span>
          <Field v-model="password" :class="`${$style.value} ${active === 1 && $style.active}`" :type="pwdShowType" @focus="handleBlur(1)">
            <template v-slot:right-icon>
              <i class="iconfont yw-chakan" @click="
                  pwdShowType = pwdShowType === 'password' ? '' : 'password'
                "></i>
            </template>
          </Field>
        </div>
        <div :class="$style.formItem">
          <span :class="`${$style.label} ${active === 2 && $style.active}`">验证码</span>
          <Field v-model="code" :class="`${$style.value} ${active === 2  && $style.active}`" @focus="handleBlur(2)">
            <template v-slot:right-icon>
              <Button plain type="info" :class="$style.verifyCode" v-if="!count" @click="getCode">获取</Button>
              <span v-else>{{count}}s</span>
            </template>
          </Field>
        </div>
        <p :class="$style.contact" @click="showCustomer">联系客服</p>
        <div :class="$style.btnGroup">
          <Button type="info" :class="$style.submit" @click="submit">确定</Button>
          <Button type="info" :class="$style.back" @click="$emit('back')">返回</Button>
        </div>
      </div>
      <i class="iconfont yw-close" @click="close"></i>
    </div>
  </div>
</template>

<script>
import { Field, Button, Dialog, Toast } from "vant";
import CountDown from "@/mixins/countDown";
import { regexpVerify } from "@/libs/account";
import { changeUserPwd, getSmsCode } from "@/apis/recall";
import { mapActions } from 'vuex';

export default {
  name: "",
  data() {
    return {
      phone: "",
      password: "",
      code: "",
      active: "",
      pwdShowType: "password",
    };
  },
  mixins: [CountDown],
  methods: {
    ...mapActions({
      showCustomer: 'recall/showCustomer'
    }),
    async submit() {
      if (!this.phone) {
        Toast('手机号不能为空')
      } else if (!this.password) {
        Toast('密码不能为空')
      } else if (!this.code) {
        Toast('验证码不能为空')
      } else {
        await changeUserPwd({
          tel_num: this.phone,
          jh_app_id: "100002638",
          code: this.code,
          password: this.password
        })
        Toast('修改成功');
        this.$emit('back', this.phone);
      }
    },
    close() {
      this.$emit('close')
    },
    handleBlur(e) {
      this.active = e;
    },
    async getCode() {
      if (!this.phone) {
        Toast('手机号不能为空')
        return;
      }
      await regexpVerify(this, [
        { key: "phone", type: "phone", hint: "请输入正确的手机号" },
      ]);
      await getSmsCode({
        tel_num: this.phone,
        jh_app_id: "100002638",
        type: 'reset'
      });
      this.setTimer();
    },
  },
  components: {
    Field,
    Button,
  },
};
</script>

<style lang="scss" module>
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 340px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .bindAccount {
      width: 351px;
      height: 271px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px;
      .notice {
        color: #9d9d9d;
        text-align: center;
        font-size: 15px;
        line-height: 18px;
        margin-bottom: 30px;
      }
      .formItem {
        display: flex;
        align-items: center;
        width: 90%;
        margin: auto;
        :global {
          .yw-chakan,
          .yw-guanbi1 {
            font-size: 13px;
            width: 18px;
            display: inline-block;
            text-align: center;
          }
        }
        .label {
          flex: none;
          color: #9d9d9d;
          margin-right: 20px;
          display: inline-block;
          &.active {
            color: #33bdfe;
          }
        }
        .value {
          padding: 5px 10px;
          @include border-bottom-1px;
          &.active {
            &::before {
              border-color: #33bdfe;
            }
          }
        }
        .verifyCode {
          height: 20px;
          line-height: 20px;
          border-radius: 20px;
          border-color: #33bdfe;
          font-size: 12px;
          padding: 0 10px;
        }
      }
      .btnGroup {
        display: flex;
        justify-content: space-evenly;
      }
      .contact {
        text-align: right;   
        text-decoration: underline;
        color: #33bdfe;
        font-size: 13px;
        padding: 5px 14px 0 0;
      }
      .submit {
        width: 123px;
        height: 38px;
        line-height: 38px;
        border-radius: 22px;
        background: linear-gradient(
          -90deg,
          rgba(36, 180, 254, 1),
          rgba(82, 208, 255, 1)
        );
        border: none;
        margin-top: 15px;
        font-size: 15px;
      }
      .back {
        @extend .submit;
        border: 1px solid #2CB9FE;
        background: #FFFFFF;
        color: #27B5FE;
      }
    }
    :global {
      .yw-close {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        color: #ffffff;
        font-size: 50px;
        z-index: 1;
        margin: auto;
        font-weight: 100;
      }
    }
  }
}
</style>